module.exports = __webpack_public_path__ + "img/checklist_close.052ce853.svg";